import { render } from "./DeleteClients.vue?vue&type=template&id=58a6563c"
import script from "./DeleteClients.vue?vue&type=script&lang=js"
export * from "./DeleteClients.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__